/**
 * Funcion encargada de transformar un objeto en un QueryParameter(String que es utilizado en las rutas).
 * @param object Parametro que recibe el objeto a convertir.
 * @param key Parametro que recibe la clave que permite acceder al objeto.
 */
export const objectToQueryParameters = (object: any, key = 'id'): string => {
  let queryParameter = '?';
  for (const k in object) {
    if (object[k]) {
      if (object[k] instanceof Array && k !== 'bounding_box') {
        if (object[k].length) {
          queryParameter += object[k]
            .map((item: any) =>
              item[key] ? `${k}=${item[key]}&` : `${k}=${item}&`
            )
            .join('');
        }
      } else {
        queryParameter += `${k}=${
          typeof object[k] === 'boolean' ? (object[k] ? 1 : 0) : object[k]
        }&`;
      }
    }
  }
  return queryParameter.slice(0, queryParameter.length - 1);
};
